import isEmpty from "lodash/isEmpty";
import React from "react";
import styled from "styled-components";
import { position, PositionProps } from "styled-system";
import { MenuItem as MenuItemProps } from "../../types/Menu";
import { Box } from "../Box";
import {
  getBorderBottom,
  getBorderColor,
  getMarginBottom,
} from "../DesktopMenu/_/selectedMenuItem";
import { DropRightMenuItem } from "../DropRightMenuItem";
import { MenuItemLink } from "../MenuItemLink";
import { DesktopMenuDropDownHeader } from "./_/DesktopMenuDropDownHeader";

interface Props {
  currentPath: string;
  // Adding new optional show arrow prop to condionallty render arrow on menu item.
  hideArrow?: boolean;
}

const Content = styled(Box)<PositionProps>`
  ${position};
  display: none;
  z-index: 100;
`;

const HoverArea = styled(Box)`
  &:hover > ${Content} {
    display: block;
  }
  position: relative;
`;

export const DesktopMenuDropDownItem: React.FC<Props & MenuItemProps> = ({
  currentPath,
  hideArrow,
  ...menuItem
}) => (
  <HoverArea
    py={2}
    borderBottom={getBorderBottom(currentPath, menuItem)}
    mb={getMarginBottom(currentPath, menuItem)}
    borderColor={getBorderColor(currentPath, menuItem)}
  >
    <DesktopMenuDropDownHeader
      url={menuItem.url}
      title={menuItem.title}
      highlightColor={menuItem.highlightColor}
      hideArrow={hideArrow}
    />
    <Content
      position="absolute"
      py={2}
      bg="white"
      borderRadius={5}
      maxWidth={220}
      minWidth={220}
      mt={2}
      mx={-1}
      boxShadow="0px 0px 7px 0px rgba(0,0,0,0.47)"
    >
      {menuItem.subMenu!.map(menu =>
        isEmpty(menu.subMenu) ? (
          <Box key={menu.title} py={2} px={3}>
            <MenuItemLink to={menu.url} color="primary" hover>
              {menu.title}
            </MenuItemLink>
          </Box>
        ) : (
          <Box key={menu.title} py={1}>
            <DropRightMenuItem {...menu} />
          </Box>
        ),
      )}
    </Content>
  </HoverArea>
);

DesktopMenuDropDownItem.defaultProps = {
  subMenu: [],
  hideArrow: true,
};
